// extracted by mini-css-extract-plugin
module.exports = {"noDevice":"NfcTagsPage_noDevice__2UM3G"};